import { Box, Button, styled, Typography } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { unit, UnstyledLink } from '@hcr/pwa/components'

import { SvgPersonMagnifier } from '../../../assets'
import { Path } from '../../../models'
import { to } from '../../../utils'
import { LayoutNavigation } from '../../common'

export const ServicesEmpty: FC = () => {
  const { t } = useTranslation()

  return (
    <LayoutNavigation stretchContentVertically>
      <Container>
        <SvgPersonMagnifier />
        <Content>
          <Typography variant='titleM'>{t('services.holiday-club-services')}</Typography>
          <Description variant='bodyM'>{t('services.choose-destination-message')}</Description>
        </Content>
        <Button
          data-testid='services-without-destination-button'
          component={UnstyledLink}
          to={to(Path.ContextMenuDestinations)}
          variant='contained'
          color='primary'
        >
          {t('services.browse-destinations')}
        </Button>
      </Container>
    </LayoutNavigation>
  )
}

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: ${unit(7)};
  padding: 0 ${unit(7)};
  height: 100%;
`

const Content = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${unit(2.5)};
`

const Description = styled(Typography)`
  text-align: center;
`
